export default __webpack_public_path__ + "static/media/office_1.33f93467.png";